import React from "react";

function ScaleToFit({ naturalWidth, naturalHeight, targetWidth, children }) {
  const scale = targetWidth / naturalWidth;

  if (scale === 1) return children;

  return (
    <div
      style={{
        width: naturalWidth * scale,
        height: naturalHeight * scale,
        overflow: "hidden",
        margin: "0 auto",
      }}
    >
      <div style={{ transform: `scale(${scale})`, transformOrigin: "top left" }}>
        {children}
      </div>
    </div>
  );
}

export default ScaleToFit;
